import { useState, useEffect } from "react";
import { CalenderDropdown } from "src/components/CalenderDropdown";
import { getAllGoodsInData1, setAllFilterDataToRedux } from "src/thunks/goodsin";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { getAllGoodsInData } from "src/thunks/goodsin";
import moment from "moment";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg";
import { getAllDispatchOrderData } from "src/thunks/dispatchOrder";
import { ProjectManagerProjectDropdown } from "src/components/projectManagerProjectDropdown";
import { ProjectManagerClientDropdown } from "src/components/projectManagerClientDropdown";
import { toast } from "react-toastify";
import { getAllItemInventoryData, getAllReportsData } from "src/thunks/reports";
import { ReportsCalenderDropdown } from "src/components/ReportsCalenderDropdown";
import { GetError } from "src/constant";
import { MonthAndYearDropdown } from "src/components/monthAndYearDropdown/dropdown";
import IconClearFilter from "src/assets/images/icon_clearfilter.svg";
import IconRefreshList from "src/assets/images/icon_refreshlist.svg";
import _ from "lodash";
import MstBerger from "./mstBurger";

function GoodsInHeader({ props, RightSidebarOpenCloseFlag }) {
  // UseSelector
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.goodsin);
  const { filterAllData } = useSelector((state) => state.goodsin);
  const clientProjects = useSelector((state) => state?.clientProjects?.clientProject);

  // UseState
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const orderedClientList = _.orderBy(userDetails?.projects, ['clientName'], ["asc"])
  const filteredArrayForClients = clientProjects?.find(client => client.id == orderedClientList?.[0]?.clientId);
  const [filterData, setFilterData] = useState({ });
  const [YearArrayToDisplay, setYearArrayToDisplay] = useState([]);

  // Variable declarations
  const ComponentName = pathname === "/app/goodsin/list" ? "goodsIn" : pathname === "/app/dispatchorders/list" ? "dispatch" : pathname === "/app/iteminventoryreport/list" ? "Inventrory" : "report";
  let monthData = [
    { name: "JAN", id: 1 },
    { name: "FEB", id: 2 },
    { name: "MAR", id: 3 },
    { name: "APR", id: 4 },
    { name: "MAY", id: 5 },
    { name: "JUN", id: 6 },
    { name: "JUL", id: 7 },
    { name: "AUG", id: 8 },
    { name: "SEP", id: 9 },
    { name: "OCT", id: 10 },
    { name: "NOV", id: 11 },
    { name: "DEC", id: 12 },
  ];

  // Useeffect
  useEffect(() => {
    if (Object.keys(filterAllData).length > 0) {
      setFilterData({ ...filterData, ...filterAllData[`${ComponentName}`] });
    }
  }, [ComponentName]);

  useEffect(() => {
    let yearArrayDisplay = [];

    const minOffset = 0;
    const maxOffset = 25;
    const thisYear = new Date().getFullYear();

    for (let i = minOffset; i <= maxOffset; i++) {
      const year = thisYear - i;
      yearArrayDisplay = [...yearArrayDisplay, { id: year, name: year }];
    }
    setYearArrayToDisplay(yearArrayDisplay);
  }, []);

  // Function Declarations
  const allFilterChange = (label, value) => {
    let changeData = {
      ...filterData,
      [label]: value,
      type: "Monthly",
    };
    if (label === "checked" && value) {
      changeData["toDate"] = new Date();
    } else if (label === "checked" && !value) {
      delete changeData["toDate"];
    }
    if (label === "clientId") {
      delete changeData["projectId"];
    }
    setFilterData({ ...changeData });
  };

  const handleRefreshListButtonClick = async () => {
    try {
      const filterClone = _.cloneDeep(filterAllData);
      filterClone[`${ComponentName}`] = { ...filterData };
      dispatch(setAllFilterDataToRedux({ ...filterClone }));
      localStorage.setItem("filterAllData", JSON.stringify(filterClone));

      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [filterData?.clientId?.id || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
      };
      if (filterData?.toDate) {
        data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
        data["isDateRange"] = true;
      }

      if (pathname == "/app/goodsin/list") {
        await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      } else if (pathname == "/app/report/list") {
        let UrlData = {
          depotId: filterData?.depotId?.id || "0",
          clientId: [filterData?.clientId?.id || 0],
          projectId: filterData?.projectId?.id || "0",
          month: filterData?.month || new Date().getMonth() + 1,
          year: filterData?.year || new Date().getFullYear(),
          type: "Monthly",
        };
        let reportResult = await dispatch(
          getAllReportsData({ ...UrlData })
        ).unwrap();
      }
      else if (pathname == "/app/iteminventoryreport/list") {
        let newdata = {
          from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
          DepotIds: [filterData?.depotId?.id || 0],
          ClientIds: [filterData?.clientId?.id || 0],
          ProjectIds: [filterData?.projectId?.id || 0],
          isDateRange: false
        };
        if (filterData?.toDate) {
          newdata["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
          newdata["isDateRange"] = true;
        }
        await dispatch(getAllItemInventoryData({ ...newdata })).unwrap();
      }
      else {
        await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleClearFilterButtonClick = async () => {
    const filterClone = _.cloneDeep(filterAllData);
    filterClone[`${ComponentName}`] = {};
    dispatch(setAllFilterDataToRedux({ ...filterClone }));
    localStorage.setItem("filterAllData", JSON.stringify(filterClone));
    setFilterData({ });

    try {
      let data = {
        isDateRange: false,
        from: moment().format("YYYY-MM-DD"),
        DepotIds: [0],
        ClientIds: [0],
        ProjectIds: [0],
      };
      if (pathname == "/app/goodsin/list") {
        await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      } else if (pathname == "/app/report/list") {
        let datas = {
          type: "Monthly",
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
          depotId: [0],
          projectId: [0],
          clientId: [0],
        }
        await dispatch(
          getAllReportsData({ ...datas })
        );
      } else if (pathname == "/app/iteminventoryreport/list") {
        let newdata = {
          isDateRange: false,
          from: moment().format("YYYY-MM-DD"),
          DepotIds: [0],
          ClientIds: [0],
          ProjectIds: [0],
        };
        await dispatch(getAllItemInventoryData({ ...newdata })).unwrap();
      }
      else {
        await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const getYearComponent = () => {
    return (
      // <div style={{ flex: 1, color: "white" }}>
      <MonthAndYearDropdown
        handleChange={(value) => allFilterChange("year", value)}
        shownDropdownValue={filterData?.year || new Date().getFullYear()}
        data={YearArrayToDisplay}
      />
      // </div>
    );
  };

  const getMonthComponent = () => {
    let monthShown = _.find(
      monthData,
      (d) => d.id === parseInt(filterData?.month || new Date().getMonth() + 1)
    )?.name;
    return (
      // <div style={{ flex: 1, color: "white" }}>
      <MonthAndYearDropdown
        handleChange={(value) => allFilterChange("month", value)}
        shownDropdownValue={monthShown}
        data={monthData}
      />
      // </div>
    );
  };

  /*
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-4 col-sm-2 col-md-2 col-lg-1">
              <img width={90} height={35} src={SigmaLogo} alt="muz image" />
          </div>
          <div className="col-3 col-sm-2 col-md-2 col-lg-1">
              {parsedProjectManagerObject?.projects[0]?.clientLogoUrl ?
                <img className="img-client-logo" src={parsedProjectManagerObject?.projects[0]?.clientLogoUrl || ""} alt="client name"></img>
                :              
                  <span className="project-name-projectMgnr-dashboard-style dashboardclientname-value-style">{parsedProjectManagerObject?.projects[0]?.clientName || ""}</span>
                }
          </div>
        </div>
      </div>
    </>
  )
  */


  return (
    <div style={{ background: "#fffff" }}>
      <div className="pm-dashboard">
        <div className="container-fluid">
          <MstBerger />
          <div className="row align-items-center justify-content-lg-end">
            <div className="col-4 col-sm-3 col-md-2 col-lg-1 col-xl-1">
              <img width={90} height={35} src={SigmaLogo} alt="muz image" />
            </div>
            {/* <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
              {parsedProjectManagerObject?.projects[0]?.clientLogoUrl ?
                <img className="img-client-logo d-inline" src={parsedProjectManagerObject?.projects[0]?.clientLogoUrl || ""} alt="client name"></img>
                :              
                  <span className="project-name-projectMgnr-dashboard-style dashboardclientname-value-style">{parsedProjectManagerObject?.projects[0]?.clientName || ""}</span>
                }
          </div> */}
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              {pathname == "/app/report/list" ? (
                <>
                  <div className="d-flex justify-content-center mt-3 mt-sm-0">
                    {getYearComponent()}
                    {getMonthComponent()}
                  </div>
                </>
              ) : (
                <CalenderDropdown
                  fromDate={moment(filterData?.fromDate || new Date()).format(
                    "YYYY-MM-DD"
                  )}
                  toDate={
                    filterData?.checked
                      ? moment(filterData?.toDate || new Date()).format(
                        "YYYY-MM-DD"
                      )
                      : null
                  }
                  previousDateShownFlag={filterData?.checked || false}
                  handleFromDate={(date) => allFilterChange("fromDate", date)}
                  handleToDate={(date) => allFilterChange("toDate", date)}
                  handlePreviousDateChange={(flag) =>
                    allFilterChange("checked", flag)
                  }
                />
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
              <ProjectManagerClientDropdown
                handleChange={(value) => allFilterChange("clientId", value)}
                clientGoodsInDropdownValue={
                  filterData?.clientId || { id: 0, name: "ALL CLIENTS" }
                }
              />
            </div>

            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-4">
              <ProjectManagerProjectDropdown
                clientId={filterData?.clientId}
                handleChange={(value) => allFilterChange("projectId", value)}
                projectGoodsInDropdownValue={
                  filterData?.projectId || { id: 0, name: "ALL PROJECTS" }
                }
              />
            </div>
            <div className="col-7 col-sm-6 col-md-3 col-lg-3 col-xl-2 mx-auto mt-3 mt-sm-0">
              <div className="d-flex mt-0 mt-sm-2 mt-lg-0">
                <div
                  onClick={handleClearFilterButtonClick}
                  className="d-flex flex-column goodsin-text-color text-center"
                  style={{
                    flex: 0.5,
                    color: "#FFFFFF",
                    fontSize: 9,
                    fontFamily: "Montserrat-Regular",
                    cursor: "pointer",
                  }}
                >
                  <p className="m-0">
                    <img
                      src={IconClearFilter}
                      width={20}
                      height={20}
                      alt="clearfilters"
                    />
                  </p>
                  <span>
                    CLEAR FILTERS
                  </span>
                </div>

                <div
                  onClick={handleRefreshListButtonClick}
                  className="d-flex flex-column goodsin-text-color text-center"
                  style={{
                    flex: 0.5,
                    color: "#FFFFFF",
                    fontFamily: "Montserrat-Regular",
                    fontSize: 9,
                    marginRight: 5,
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                >
                  <p className="m-0">
                    <img
                      src={IconRefreshList}
                      width={20}
                      height={20}
                      alt="clearfilters"
                    />
                  </p>
                  <span>REFRESH LIST</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>



      {/* <div
        className={`${ == true ? "add-overlay-for-depot-dropdown" : ""
          }`}
        style={{
          display: "flex",
          alignItems: "center",
          flex: 10,
          height: 60,
          backgroundColor: "#0045d9",
        }}
      >
        <div style={{ flex: 1 }} className="ms-2">
          <img width={90} height={35} src={SigmaLogo} alt="muz image" />
        </div>

        {parsedProjectManagerObject?.projects[0]?.clientLogoUrl ? (
          <div className="d-flex justify-content-center" style={{ flex: 1.4 }}>
            <div className="clientlogo-container">
              <img
                className="img-client-logo"
                src={
                  parsedProjectManagerObject?.projects[0]?.clientLogoUrl || ""
                }
                alt="client name"
              ></img>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1.4 }}>
            <span className="project-name-projectMgnr-dashboard-style dashboardclientname-value-style">
              {parsedProjectManagerObject?.projects[0]?.clientName || ""}
            </span>
          </div>
        )}

        <div
          className="d-flex goodsin-text-color text-uppercase"
          style={{
            flex: 2,
            color: "#FFFFFF",
            fontFamily: "Montserrat-Regular",
            fontSize: 15,
          }}
        >
          {pathname == "/app/report/list" ? (
            <>
              <div
                style={{
                  flex: 1,
                  color: "#FFFFFF",
                  fontFamily: "Montserrat-Regular",
                  fontSize: 15,
                }}
              >
                {getYearComponent()}
              </div>
              <div
                style={{
                  flex: 1,
                  color: "#FFFFFF",
                  fontFamily: "Montserrat-Regular",
                  fontSize: 15,
                }}
              >
                {getMonthComponent()}
              </div>
            </>
          ) : (
            <CalenderDropdown
              fromDate={moment(filterData?.fromDate || new Date()).format(
                "YYYY-MM-DD"
              )}
              toDate={
                filterData?.checked
                  ? moment(filterData?.toDate || new Date()).format(
                    "YYYY-MM-DD"
                  )
                  : null
              }
              previousDateShownFlag={filterData?.checked || false}
              handleFromDate={(date) => allFilterChange("fromDate", date)}
              handleToDate={(date) => allFilterChange("toDate", date)}
              handlePreviousDateChange={(flag) =>
                allFilterChange("checked", flag)
              }
            />
          )}
        </div>

        <div style={{ flex: 1.7, color: "white" }}>
          <ProjectManagerProjectDropdown
            handleChange={(value) => allFilterChange("projectId", value)}
            projectGoodsInDropdownValue={
              filterData?.projectId || { id: 0, name: "ALL PROJECTS" }
            }
            ProjectData={parsedProjectManagerObject?.projects}
          />
        </div>

        <div style={{ flex: 1.3 }}></div>

        <div
          onClick={handleClearFilterButtonClick}
          className="d-flex flex-column goodsin-text-color"
          style={{
            flex: 0.5,
            color: "#FFFFFF",
            fontSize: 9,
            fontFamily: "Montserrat-Regular",
            cursor: "pointer",
          }}
        >
          <img
            src={IconClearFilter}
            width={20}
            height={20}
            alt="clearfilters"
          />
          CLEAR FILTERS
        </div>

        <div
          onClick={handleRefreshListButtonClick}
          className="d-flex flex-column goodsin-text-color"
          style={{
            flex: 0.5,
            color: "#FFFFFF",
            fontFamily: "Montserrat-Regular",
            fontSize: 9,
            marginRight: 5,
            marginLeft: 5,
            cursor: "pointer",
          }}
        >
          <img
            src={IconRefreshList}
            width={20}
            height={20}
            alt="clearfilters"
          />
          REFRESH LIST
        </div>
      </div> */}
    </div>
  );

}

export default GoodsInHeader;
